import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';

export const SEND_CHEER_ROUTE = {
  name: 'sendcheer/:studentId',
  route(classId: string, studentId: string): string[] {
    return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), 'sendcheer', studentId];
  }
};
